var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0 -0.135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 27,
    height: 27,
    transform: "translate(0 0.135)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(4.5 3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M19.125,23.625v-2.25a4.5,4.5,0,0,0-4.5-4.5h-9a4.5,4.5,0,0,0-4.5,4.5v2.25",
    transform: "translate(-4.5 -3.375)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Path-2",
    "data-name": "Path",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(1.125)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M25.875,23.625v-2.25A4.5,4.5,0,0,0,22.5,17.021",
    transform: "translate(-4.5 -3.375)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M18,3.521a4.5,4.5,0,0,1,0,8.719",
    transform: "translate(-4.5 -3.375)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.a64cc85f166847600c57654bdf180fa3.svg";
export { ForwardRef as ReactComponent };